import {Auditable} from "../shared/auditable.model";
import {UserModel} from "./user.model";

export class AssetTypeModel extends Auditable {
  id: number;
  name: string = '';
  description: string = '';

  account_id: number = 0;
  parent_id: number = 0;

  parent: AssetTypeModel;
  children: AssetTypeModel[];

  linked_assets_count: number = 0;
  children_count: number = 0;
  children_linked_assets_count: number = 0;
  total_linked_assets_count: number = 0;

  /**
   * Who created this Asset Type?
   */
  created_by_user: UserModel;

  /**
   * Who updated this Asset Type?
   */
  updated_by_user: UserModel;
}
